import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ba73626&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=4ba73626&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba73626",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ba73626')) {
      api.createRecord('4ba73626', component.options)
    } else {
      api.reload('4ba73626', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ba73626&scoped=true", function () {
      api.rerender('4ba73626', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/workbench/components/workTotal/index.vue"
export default component.exports